import { ReactNode } from 'react';
import { Text } from '@mercator-gcp/grout';
import { FlexColumn } from 'components/layout/FlexColumn/FlexColumn';

const inputWrapperStyle = {
  gap: 'padding_4',
  width: '100%',
};

interface WithLabelProps {
  label?: string;
  children: ReactNode;
}

const WithLabel = ({ label, children }: WithLabelProps) => {
  if (!label) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{children}</>;
  }

  return (
    <FlexColumn sx={inputWrapperStyle}>
      {label && <Text.SmallLabel>{label}</Text.SmallLabel>}
      {children}
    </FlexColumn>
  );
};

export default WithLabel;
